import React from "react";
import ServicePortfolioCarousel from "../ServicePortfolioCarousel/ServicePortfolioCarousel";

const ServicePortfolioSlider = (props) => {
  const { servicePortfolioSliderProps } = props;
  return (
    <section className="py-3">
      <div className="container-fluid pt-5">
        <div className="row m-0">
          <div className="col-12 text-center p-0">
            <p className="let-space-2 text-grey">
              {servicePortfolioSliderProps.portfolioCaption}
            </p>
            <hr className="line-bot-green-74 mx-auto" />
            <h3 className="font-45 text-dark text-dark font-w700 position-relative">
              {servicePortfolioSliderProps.portfolioTitle}
            </h3>
            <p className="font-180 font-w900 text-portfolio mb--45">
              PORTFOLIO
            </p>
            <ServicePortfolioCarousel
              servicePortfolioSliderProps={servicePortfolioSliderProps}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicePortfolioSlider;
